export function Splitter(splitterParam: ISplitterParameters) {
    this._onSplitEnd = $.noop;

    this._splitterParam = $.extend(
        {
            disable: false,
            width: null,
            height: null,
            isVertical: true,
            colspan: 1,
            rowspan: 1,
            containment: null,
            splitterMin: null,
            returnAreaControl: false,
            resetOffset: false
        },
        splitterParam
    );

    this._position = null;
    this._splitter = $('<div class="splitter-area"><div class="splitter-line"></div></div>').css('position', 'absolute');
    this._splitterParam.height && this._splitter.height(this._splitterParam.height);
    this._splitterParam.width && this._splitter.width(this._splitterParam.width);

    if (!this._splitterParam.disable) {
        this._splitter.draggable({
            zIndex: 10000,
            axis: this._splitterParam.isVertical ? 'x' : 'y',
            containment: this._splitterParam.containment,
            scroll: false,
            start: function () {
                this._position = this._splitter.offset();
                this._splitter.find('.splitter-line').addClass('active');
            }.bind(this),
            stop: function () {
                let offset = this._splitterParam.isVertical
                    ? this._position.left - this._splitter.offset().left
                    : this._position.top - this._splitter.offset().top;

                if (offset < 0) {
                    offset += this._splitterParam.splitterMin / 2;
                } else {
                    offset -= this._splitterParam.splitterMin / 2;
                }

                offset = Math.round(offset);

                if (this._splitterParam.resetOffset) {
                    this._splitter.css({ top: '0px', left: '0px' });
                }

                this._onSplitEnd(offset);
            }.bind(this)
        });
    }

    this._td = $('<td class="splitter"/>')
        .toggleClass('disabled', this._splitterParam.disable === true)
        //.filter(function() { return !splitterParam.disable; })
        .append(this._splitter)
        //.end()
        .addClass(this._splitterParam.isVertical ? 'vertical' : 'horizontal')
        .attr('rowspan', this._splitterParam.rowspan)
        .attr('colspan', this._splitterParam.colspan);
}

Splitter.prototype.getControl = function () {
    return this._splitterParam.returnAreaControl ? this._splitter : this._td;
};

Splitter.prototype.onSplitEnd = function (fn) {
    $.isFunction(fn) && (this._onSplitEnd = fn);
};

Splitter.prototype.isVertical = function () {
    return this._splitterParam.isVertical;
};

Splitter.prototype.getSplitterArea = function () {
    return this._splitter;
};

export interface ISplitterParameters {
    disable?: boolean;
    width?: any;
    height?: any;
    isVertical?: boolean;
    colspan?: number;
    rowspan?: number;
    containment?: any;
    splitterMin?: any;
    returnAreaControl?: boolean;
    resetOffset?: boolean;
}

export interface Splitter {
    onSplitEnd(fn);

    isVertical(): boolean;

    getSplitterArea();

    getControl(): JQuery;
}
